import React from 'react';
import ReactGA from 'react-ga';
import config from 'config';
import {withRouter} from 'react-router-dom';

ReactGA.initialize(config.gaTrackerId);

export const pageview = (page, options = {}) => {
    ReactGA.pageview(page, options.trackers, options.title);
};

export const modalview = (modalName) => {
    ReactGA.modalview(modalName);
};

class GAListener extends React.Component {
    componentDidMount() {
        this.sendPageView(this.props.history.location);
        this.props.history.listen(this.sendPageView);
    }
  
    sendPageView(location) {
        ReactGA.pageview(location.pathname);
    }
  
    render() {
        return this.props.children;
    }
}

export default withRouter(GAListener);